import { SOPMedia } from '../api/sopMedia';

export const USEFUL_MEDIA_TYPES = {
  video: ['video/mp4', 'video/mov', 'video/avi', 'video/quicktime'],
  image: ['image/jpeg', 'image/png', 'image/webp'],
  document: ['application/pdf', 'image/svg+xml'],
};

export const EXCLUDED_MEDIA_TYPES = {
  step_files: ['application/step', 'model/step', 'text/plain'],
  large_files: ['application/octet-stream', 'application/zip'],
};

export interface FilteredMedia {
  videos: SOPMedia[];
  images: SOPMedia[];
  /** Reference documents (PDFs, etc.) for document preview. From original_media with type 'document' or file_type application/pdf. */
  documents: SOPMedia[];
  extractedFrames: Array<{ id: string; url: string; timestamp: number; image_ref_id?: string }>;
  extractedRenders: Array<{ 
    id: string; 
    url: string; 
    image_ref_id?: string; 
    view_name: string; 
    view_type: string; 
    width: number; 
    height: number; 
  }>;
}

export function filterSOPMedia(media: SOPMedia[]): FilteredMedia {
  const filtered: FilteredMedia = {
    videos: [],
    images: [],
    documents: [],
    extractedFrames: [],
    extractedRenders: [],
  };

  for (const item of media) {
    // Skip large files but allow step files for their renders
    if (EXCLUDED_MEDIA_TYPES.large_files.includes(item.file_type)) {
      continue;
    }

    if (item.type === 'document' || item.file_type === 'application/pdf') {
      filtered.documents.push(item);
    } else if (item.type === 'video') {
      filtered.videos.push(item);
      
      if (item.extracted && item.extracted.frames) {
        filtered.extractedFrames.push(...item.extracted.frames.map(frame => ({
          id: frame.id,
          url: frame.url,
          timestamp: frame.timestamp,
          image_ref_id: frame.image_ref_id
        })));
      }
    } else if (item.type === 'image' || item.type === 'render') {
      filtered.images.push(item);
    } else if (item.type === 'step_file') {
      filtered.documents.push(item);
      if (item.extracted && item.extracted.renders) {
        filtered.extractedRenders.push(...item.extracted.renders.map(render => ({
          id: render.id,
          url: render.url,
          image_ref_id: render.image_ref_id,
          view_name: render.view_name,
          view_type: render.view_type,
          width: render.width,
          height: render.height
        })));
      }
    }
  }

  return filtered;
} 